export default "__VITE_ASSET__9w3xVrLG__"